import { useGetUserByIdLazyQuery } from "graphql/__generated__/hooks";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { ROLES, User } from "types/user";

export const useUserDetail = () => {
  const { userId } = useParams();
  const [getUserById, { data, loading, error }] = useGetUserByIdLazyQuery();

  useEffect(() => {
    if (userId) {
      getUserById({ variables: { userId } });
    }
  }, [userId]);

  const user = useMemo<User | null>(() => {
    if (data?.user_by_pk) {
      return {
        user_id: data.user_by_pk.user_id,
        email: data.user_by_pk.email,
        name: data.user_by_pk.name,
        role: data.user_by_pk.role as ROLES,
        picture_url: data.user_by_pk.picture_url ?? undefined,
        updated_at: data.user_by_pk.updated_at,
        tags: data.user_by_pk.tags ?? [],
        organization:
          data.user_by_pk.organization?.map((org) => org.organization) ?? [],
      } as User;
    }
    return null;
  }, [data]);
  const organizations = useMemo(() => {
    if (data?.user_by_pk?.organization) {
      return data.user_by_pk.organization.map((org) => org.organization);
    }
    return [];
  }, [data]);
  const organization = useMemo(() => {
    if (
      data?.graduation_class_student[0]?.graduation_class?.program?.organization
    ) {
      return data.graduation_class_student[0]?.graduation_class?.program
        ?.organization;
    }
    return null;
  }, [data]);

  const graduationClass = useMemo(() => {
    if (
      data?.graduation_class_student &&
      data?.graduation_class_student?.length > 0
    ) {
      return data?.graduation_class_student[0]?.graduation_class;
    }
    return null;
  }, [data]);

  const mentors = useMemo<User[]>(() => {
    const list = data?.mentoring?.map((m) => m.mentor) || [];
    return list as User[];
  }, [data]);

  return {
    user,
    userId,
    loading,
    error,
    graduationClass,
    organizations,
    organization,
    mentors,
  };
};
